import React from 'react';
import clsx from 'clsx';
import './style.css';

type Props = {
	children: string | JSX.Element | JSX.Element[] | (string | JSX.Element)[];
	className?: string;
	id?: string;
	uncentered?: boolean;
	minHeight?: number;
	collapsed?: boolean;
	collapsedTop?: boolean;
	collapsedBottom?: boolean;
	unset?: boolean;
	style?: Record<string, unknown> | {};
};

export const Section = ({
	children,
	style = {},
	minHeight,
	className,
	id,
	uncentered = false,
	collapsed = false,
	collapsedTop = false,
	collapsedBottom = false,
	unset = false,
}: Props) => {
	return (
		<section
			className={clsx(
				'section',
				className,
				{ 'section--uncentered': uncentered },
				{ 'section--collapsed': collapsed },
				{ 'section--collapsed-t': collapsedTop },
				{ 'section--collapsed-b': collapsedBottom },
				{ 'section--unset': unset }
			)}
			id={id}
			style={minHeight ? { ...style, minHeight } : { ...style }}
		>
			{children}
		</section>
	);
};
